<template>
  <div class="favorites-page">
    <AppNavbar />

    <div class="page-container">
      <h2 class="page-title">My Favorites</h2>

      <div class="group-tabs">
        <button 
          v-for="group in groupNames" 
          :key="group" 
          :class="['tab-btn', { active: activeGroup === group }]"
          @click="activeGroup = group"
        >
          {{ group }} ({{ allGroups[group].length }})
        </button>
      </div>

      <div v-if="activeGroup !== 'Default'" class="group-actions">
        <button class="btn-delete-group" @click="confirmDeleteGroup">Delete '{{ activeGroup }}' Group</button>
      </div>

      <div class="card-flex-container">
        <div 
          v-for="character in displayList" 
          :key="character.id"
          class="card"
          @click="openDetails(character)"
        >
          <div class="image-wrapper">
             <img v-if="getMediaType(character.path) === 'image'" :src="resolveUrl(character.path)" />
             <video v-else-if="getMediaType(character.path) === 'video'" :src="resolveUrl(character.path)" class="media-player"></video>
             <div v-else-if="getMediaType(character.path) === 'audio'" class="audio-container">
                <i class="fas fa-music"></i>
             </div>
             <iframe v-else :src="character.path" class="media-player"></iframe>
          </div>
          <div class="card-content">
            <h3>{{ character.name }}</h3>
            <button class="btn-remove" @click.stop="removeFromGroup(character.id)">
              <i class="fas fa-trash"></i>
            </button>
          </div>
        </div>

        <div v-if="displayList.length === 0" class="empty-state">
          <p>No items in this group.</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '../services/api';
import favService from '../services/favorites';
import AppNavbar from './AppNavbar.vue';

export default {
  components: { AppNavbar },
  data() {
    return {
      allGroups: {},
      activeGroup: 'Default',
      allCharacters: []
    };
  },
  computed: {
    groupNames() {
      return Object.keys(this.allGroups).sort();
    },
    displayList() {
      const ids = this.allGroups[this.activeGroup] || [];
      return this.allCharacters.filter(c => ids.includes(String(c.id)));
    }
  },
  methods: {
    resolveUrl(path) { if (!path) return ''; return path.startsWith('/shared/online/') ? 'https://lms.unb.ca' + path : path; },
    getMediaType(path) {
      if (!path) return 'image'; path = path.toLowerCase().split('?')[0];
      if (path.includes('youtube') || path.includes('vimeo')) return 'embed';
      if (path.endsWith('.mp4')) return 'video';
      if (path.endsWith('.mp3')) return 'audio';
      return 'image';
    },
    async loadData() {
      this.allGroups = favService.getGroups();
      this.allCharacters = await api.getAllCharacters();
      
      // Safety check: if active group was deleted, switch to Default
      if (!this.allGroups[this.activeGroup]) this.activeGroup = 'Default';
    },
    openDetails(character) {
      this.$router.push({ name: 'CharacterDetails', params: { id: character.id } });
    },
    removeFromGroup(id) {
      favService.removeFromGroup(id, this.activeGroup);
      this.loadData();
    },
    confirmDeleteGroup() {
      if (confirm(`Are you sure you want to delete the group "${this.activeGroup}"? Items will remain in the database, but this list will be gone.`)) {
        favService.deleteGroup(this.activeGroup);
        this.activeGroup = 'Default';
        this.loadData();
      }
    }
  },
  mounted() {
    this.loadData();
  }
};
</script>

<style scoped>
.page-container { padding: 20px; max-width: 1200px; margin: 0 auto; }
.page-title { margin-bottom: 20px; }

/* TABS */
.group-tabs { display: flex; gap: 10px; border-bottom: 2px solid #ddd; padding-bottom: 0; margin-bottom: 20px; overflow-x: auto; }
.tab-btn { background: none; border: none; padding: 10px 20px; font-size: 16px; cursor: pointer; border-bottom: 3px solid transparent; font-weight: bold; color: #666; white-space: nowrap; }
.tab-btn:hover { color: #333; }
.tab-btn.active { border-bottom-color: var(--accent-color); color: var(--accent-color); }

.group-actions { display: flex; justify-content: flex-end; margin-bottom: 10px; }
.btn-delete-group { background: #fee; color: #c0392b; border: 1px solid #c0392b; padding: 6px 12px; border-radius: 4px; cursor: pointer; }

/* CARDS */
.card-flex-container { display: flex; flex-wrap: wrap; gap: 20px; }
.card { width: 200px; border: 1px solid #ddd; border-radius: 8px; overflow: hidden; cursor: pointer; transition: transform 0.2s; }
.card:hover { transform: scale(1.02); }
.image-wrapper { height: 150px; background: #eee; display: flex; align-items: center; justify-content: center; }
.image-wrapper img, .media-player { width: 100%; height: 100%; object-fit: cover; }
.card-content { padding: 10px; display: flex; justify-content: space-between; align-items: center; }
.card-content h3 { margin: 0; font-size: 14px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; max-width: 150px; }
.btn-remove { background: none; border: none; color: #999; cursor: pointer; }
.btn-remove:hover { color: red; }
.empty-state { width: 100%; text-align: center; color: #777; padding: 40px; }
</style>